import { DOCUMENT, inject, Injectable } from '@angular/core';
import { CepStateService } from '@libs/shared/common';
import { ProductBaseModel} from '@libs/shop/models';
import { ProductTrackingModel, TrackingProductModel } from '@libs/shop/models';
import { getTrackingPagePath } from '../context';
import { TrackingMapperService } from '../mapper';
import { TrackingGoogleService } from '../services';

@Injectable({ providedIn: 'root' })
export class ProductClickTrackingService {

  private readonly document: Document = inject(DOCUMENT);
  private readonly tracking: TrackingGoogleService = inject(TrackingGoogleService);
  private readonly trackingMapper: TrackingMapperService = inject(TrackingMapperService);
  private readonly cepStateService: CepStateService = inject(CepStateService);

  public trackProductClick(product: ProductBaseModel, position: number, trackingList: string | undefined = undefined): void {
    trackingList ??= getTrackingPagePath(this.document);

    const trackingProducts: TrackingProductModel[] = [{ ...product, quantity: 1, position, type: 'product' }];
    const products: ProductTrackingModel[] = this.trackingMapper.mapProductToProductTracking(trackingProducts, trackingList);
    const searchTerm: string | null = this.cepStateService.getProductSearchTerm(trackingList);

    this.tracking.trackProductClickEvent(products, searchTerm);
  }
}
